var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParkingSpotMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-85 -55 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9284 0.450954C72.4378 0.450954 90.9021 19.0916 90.9021 45.7624C90.9021 58.4217 86.6555 69.5869 78.6316 77.6164C70.9806 85.2674 60.5981 89.4726 48.538 89.9993L45.9284 90.0558L27.3505 90.054L27.3518 133.546C27.3518 140.037 22.607 145.548 16.438 146.755L15.1862 146.938L13.9023 147C7.08231 147 1.33161 141.55 0.678658 134.821L0.616943 133.546V16.1056C0.616943 7.96883 7.04517 1.19894 15.0862 0.508862L16.4405 0.450954H45.9284ZM45.9284 26.6744L27.3505 26.667V63.8279L45.9284 63.8323C52.073 63.8323 56.9242 62.0653 59.8334 59.156C62.5778 56.4116 64.1672 51.8283 64.1672 45.7624C64.1672 39.5904 62.4539 34.7668 59.4909 31.6885C56.6254 28.823 52.7222 27.09 47.8154 26.7402L45.9284 26.6744Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingSpotMarker);
export default __webpack_public_path__ + "static/media/parkingSpot_marker.eda8fe68062cf4d5fcdb70908c9572c8.svg";
export { ForwardRef as ReactComponent };